module.exports = __webpack_public_path__ + "img/a-propos-prestations-1.0130c749.png";